module.exports = __webpack_public_path__ + "img/GR-logo.250.5c59a63b.png";